import Sidebar from '../components/Sidebar';
import { useMainNavLinks } from '../hooks/useNavLinks';

const LayoutWithSidebar = () => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  return (
    <Sidebar links={useMainNavLinks()} username={user?.username} />
  );
}

export default LayoutWithSidebar;
